const STORAGE_KEY = 'admin_auth';

/**
 * Get the stored access token for admin API requests.
 * @returns {string|null}
 */
export function getAccessToken() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed?.accessToken ?? null;
  } catch {
    return null;
  }
}

/**
 * Store auth data from login response (accessToken, refreshToken, admin).
 * @param {{ accessToken: string; refreshToken?: string; admin?: object }} data
 */
export function setAuth(data) {
  if (!data?.accessToken) return;
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({
      accessToken: data.accessToken,
      refreshToken: data.refreshToken ?? null,
      admin: data.admin ?? null,
    }));
  } catch {
    // ignore storage errors
  }
}

/**
 * Clear stored auth (e.g. on sign out).
 */
export function clearAuth() {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
}
